import React from 'react';
import { ThemeProvider as StyledProvider } from 'styled-components';
import { themeLight } from '../../theme/index';
// Replace the values in defaultTheme with the same keys in the theme being passed
export const ThemeProvider = ({ children, theme = {} }) => {
    return <StyledProvider theme={{ ...themeLight, ...theme }}>{children}</StyledProvider>;
};
export default ThemeProvider;
